import { createContext, useContext } from "react";

import { campaignKey, type CampaignKey } from "@/campaigns/campaign-key";
import type { CampaignSchema } from "@/types";

/**
 * The campaign the opt-in prompt is covering the page for right now, or null. The page's other
 * Opt In buttons (the floating pill, the desktop sidebar card, the landscape pane's) read it and
 * step aside, so the player is asked once, not three times at once.
 */
export const OptInPromptContext = createContext<CampaignKey | null>(null);

export const useOptInPromptShowing = (campaign: CampaignSchema): boolean =>
  useContext(OptInPromptContext) === campaignKey(campaign);
